import getQueryParams from './query-parser';

export default function(validPages) {
  const hashPage = getPageFromHash(window.location.href);
  if (validPages.indexOf(hashPage) > -1) {
    return hashPage;
  }

  const queryParams = getQueryParams(window.location.search);

  if ('page' in queryParams === false
  && hashPage === undefined) {
    return;
  }

  if (validPages.indexOf(queryParams.page) > -1) {
    return queryParams.page;
  }

  const urlBase = window.location.href.split('#')[0].split('?')[0];
  const validPageLinks = validPages.map((page) => {
    const link = urlBase + '?page=' + page;
    return `<a target="_top" href=${link}>${page}</a>`;
  });

  setTimeout(() => {
    document.write(['Valid "page" values:', ...validPageLinks].join('<br />'));
  }, 0);
};

function getPageFromHash(url) {
  return url.indexOf('#') > -1 ? url.split('#')[1] : undefined;
}
